import { BrowserRouter } from 'react-router-dom';
import { MenuProvider } from './contexts/MenuContext';
import { urlDefault } from './constants/config';
import RoutesLayout from './layouts/RouteLayout';
import { rootRoutes } from './routes/routes';
import Users from 'src/modules/users';
import { StatusProvider } from './pages/DashboardPage/acadia/notificationPage';
import HeadInfo from './modules/headInfo';
import MaintenancePage from './pages/MaintenancePage';

const App = () => {
  return (
    <BrowserRouter basename={urlDefault}>
      {/* <MaintenancePage type='main' /> */}
      <HeadInfo />
      <Users />
      <HeadInfo />
      <MenuProvider>
        <StatusProvider>
          <div className='min-h-screen bg-sp-gray'>
            <RoutesLayout routes={rootRoutes} />
          </div>
        </StatusProvider>
      </MenuProvider>
    </BrowserRouter>
  );
};

export default App;
